"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { EducationAvailability } from "@/hooks/useEducationAvailability";

type Props = { availability: EducationAvailability & { retry: () => void } };

export default function AvailabilityNotice({ availability }: Props) {
  const t = useTranslations("EducationListing");
  if (availability.status === "supported") return null;

  return (
    <section className="border-top border-bottom py-4 mb-4" role="status" aria-live="polite">
      {availability.status === "loading" ? <p className="mb-0">{t("AvailabilityLoading")}</p> : (
        <>
          <h2 className="h5">{t(availability.status === "unknown" ? "AvailabilityUnknownTitle" : "AvailabilityUnsupportedTitle")}</h2>
          <p className="mb-0">{t(availability.status === "unknown" ? "AvailabilityUnknownDescription" : "AvailabilityUnsupportedDescription")}</p>
          {availability.status === "unknown" && (
            <button type="button" className="btn btn-outline-secondary mt-3" onClick={availability.retry}>
              <i className="bi bi-arrow-clockwise me-2" aria-hidden="true" />
              {t("AvailabilityRetry")}
            </button>
          )}
        </>
      )}
    </section>
  );
}